/**
 * Checks if the provided value is a number that is greater than 0
 * @param value
 * @param greaterThan
 */
export const isPositiveNumber = (value: unknown, greaterThan = 0): boolean => {
	if (typeof value != 'number') return false
	return value > greaterThan
}
